module.exports = __webpack_public_path__ + "img/Withdraw-icon.8bf4f887.svg";